import axiosClient from './axiosClient'

const productsItemsApi = {
  assignMultipleProductsCategory: (data) => {
    const url = '/assign-multiple-product-category'
    return axiosClient.patch(url, data)
  },

  assignProducCategory: (data) => {
    const url = '/assign-product-category'
    return axiosClient.patch(url, data)
  },

  getListProductsByHost: (params = {}) => {
    const { groupId, lastProductTimestamp, lastProductId } = params
    if (!groupId) return Promise.reject(new Error('groupId is required'))
    const url = '/get-products-by-host'
    return axiosClient.get(url, {
      params: {
        groupId,
        lastProductTimestamp,
        lastProductId,
      },
    })
  },

  searchProductsByHost: (params = {}) => {
    const { groupId, searchString, lastProductTimestamp, lastProductId } = params
    if (!groupId) return Promise.reject(new Error('groupId is required'))
    if (!searchString) return Promise.reject(new Error('keyword (searchString) is required'))

    const url = '/search-product'
    return axiosClient.get(url, {
      params: {
        groupId,
        keyword: searchString,
        lastProductTimestamp,
        lastProductId,
      },
    })
  },

  editProduct: (id, data) => {
    if (!id) return Promise.reject(new Error('productId is required'))

    const url = `/edit-product?id=${id}`
    return axiosClient.patch(url, data)
  },

  addProductToEvent: (eventId, data) => {
    if (!eventId) return Promise.reject(new Error('eventId is required'))
    const url = `/add-product-to-event?eventId=${eventId}`
    return axiosClient.post(url, data)
  },

  deleteProduct: (productId, eventId) => {
    if (!productId) return Promise.reject(new Error('productId is required'))
    if (!eventId) return Promise.reject(new Error('eventId is required'))
    const url = '/delete-product'
    return axiosClient.delete(url, { data: { productId, eventId } })
  },

  deleteMultipleProducts: (data) => {
    const url = '/delete-multiple-product'
    return axiosClient.delete(url, { data })
  },
}

export default productsItemsApi
